import React, { useEffect } from "react";
import "./about.css";
import Aos from "aos";
import "aos/dist/aos.css";
import { NavLink } from "react-router-dom";

const About = () => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  return (
    <div className="container py-5">
      <div className="row align-items-center mb-2">
        <div className="col-md-6" data-aos="fade-right">
          <h2 className="text-dark fw-bold mb-4">
            मराठवाडा सामाजिक फाऊंडेशन बद्दल{" "}
          </h2>
          <p className="about-text fs-6" style={{ textAlign: "justify" }}>
            महाराष्ट्र राज्यातील मराठवाड्यातील आठही जिल्हे नेहमीच दुष्काळ ग्रस्त
            आहेत या संकटामुळे लाखोंच्या संख्येने नागरिक नाशिक, पुणे, मुंबई,
            छत्रपती संभाजीनगर, नागपूर इत्यादी शहरांमध्ये स्थलांतर करतात. या
            स्थलांतरामुळे ग्रामीण भागात विकास खुंटतो, आणि शहरात स्थलांतरित
            झालेल्या नागरिकांना अनेक अडचणींचा सामना करावा लागतो. कोरोना
            महामारीने संपूर्ण जगाला घेरून घेतले होते. त्यातच मराठवाड्यातून
            स्थलांतरित झालेल्या नागरिकांना खूप मोठा त्रास सहन करावा लागला ना
            हाताला काम मिळत नव्हते, राहण्याची सुविधा नाही, अन्नधान्याची सुविधा
            नाही, एवढेच नाही तर कोणी कुटुंबातील एखादी व्यक्तीचे निधन झाले तर
            त्याचा अंत्यविधी करण्यासाठी कोणीही उपलब्ध राहत नसे, एवढ्या मोठ्या
            वेदना मराठवाड्यातील नागरिकावरती येत असतात. महाराष्ट्रात सर्वात जास्त
            शेतकरी आत्महत्या या मराठवाड्यात होत असतात या आत्महत्यामुळे अनाथ
            बालके, विधवा महिला यांना आपल्या उपजीविका भागवण्यासाठी तसेच शिक्षण
            ,आरोग्य, यासाठी खूप मोठा आर्थिक सामना करावा लागतो. यातूनच मराठवाडा
            सामाजिक फाऊंडेशन ची स्थापना करण्यात आली. मागील काही वर्षांपासून
            आम्ही हजारो कुटुंबांच्या आयुष्यात आशेचा नवा किरण बनून पोहोचलो आहोत.
          </p>
          <div className="btn btn-danger btn-sm">
            <NavLink to="/about" className=" text-white">
              Read More
            </NavLink>
          </div>
        </div>
        <div className="col-md-6 text-center" data-aos="fade-left">
          <img
            src="/photo/DSC_0178.JPG"
            className="img-fluid rounded "
            alt="About us"
          />
        </div>
      </div>

      {/* Vision and Mission Section */}
      <div className="row g-4 mt-4">
        <div className="col-md-6">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body text-center">
              {/* <FaEye size={40} className="text-success mb-3" /> */}
              <h4 className="fw-bold text-dark mb-3">संस्थेचे व्हिजन</h4>
              <p className="text-muted" style={{ textAlign: "justify" }}>
                मराठवाड्यातील दुष्काळग्रस्त, गरजू, स्थलांतरित आणि उपेक्षित
                घटकांना शाश्वत विकासाच्या वाटेवर नेऊन त्यांचे जीवनमान उंचावणे हे
                आमचे प्रमुख व्हिजन आहे. त्यांना शिक्षण, आरोग्य, रोजगार, महिला
                सशक्तीकरण व कृषी क्षेत्रातील प्रगतीसाठी संधी उपलब्ध करून देणे,
                सामाजिक न्याय आणि समतेचे मूल्य जोपासणे, तसेच आत्मनिर्भरतेकडे
                वाटचाल घडवून आणणे हाच आमचा अंतिम उद्देश आहे.
              </p>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body text-center">
              {/* <FaBullseye size={40} className="text-danger mb-3" /> */}
              <h4 className="fw-bold text-dark mb-3">संस्थेचे मिशन</h4>
              <p className="text-muted" style={{ textAlign: "justify" }}>
                मराठवाड्यातील दुष्काळग्रस्त भागातील शिक्षण, आरोग्य, महिला
                सक्षमीकरण, युवकांना कौशल्य प्रशिक्षण आणि सामाजिक न्याय या
                क्षेत्रांमध्ये सेवा देऊन मराठवाडा भागाचा सर्वांगीण विकास घडवणे
                हे आमचे मिशन आहे. ग्रामीण भागातील वंचित समाजघटकांना सक्षम बनवून
                त्यांना मुख्य प्रवाहात आणणे, पर्यावरणपूरक उपक्रमांना प्रोत्साहन
                देणे, आणि समाजात आत्मविश्वास, सक्षमता व समतेची जाणीव निर्माण
                करणे हे आमचे प्रमुख उद्दिष्ट आहे.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
